<template>
  <div class="areaPage">
    <van-tabs v-model="active" swipeable class="areaTab" >
      <van-tab title="门" name="province" class="tabList">
        <div class="provinceBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="mencatlogData == ''">无匹配数据</p>
          <van-radio-group v-model="menRadio">
            <van-cell-group>
              <van-cell
                v-for="(item,index) in mencatlogData"
                :key="item.code"
                :title="`${item.name}`"
                clickable
                @click="getCityData(active,item,index)"
              >
                <van-radio slot="right-icon" checked-color="#4ac08a" :name="index" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
      <van-tab title="纲" name="city" class="tabList">
        <div class="cityBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="gangCatlogData == ''">无匹配数据</p>
          <van-radio-group v-model="gangRadio">
            <van-cell-group>
              <van-cell
                v-for="(item,index) in gangCatlogData"
                :key="item.code"
                :title="`${item.name}`"
                clickable
                @click="getAreaData(active,item,index)"
              >
                <van-radio slot="right-icon" checked-color="#4ac08a" :name="index" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
      <van-tab title="目" name="area" class="tabList">
        <div class="areaBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="muCatlogData == ''">无匹配数据</p>
          <van-radio-group v-model="muRadio">
            <van-cell-group>
              <van-cell
                v-for="(item,index) in muCatlogData"
                :key="item.code"
                :title="`${item.name}`"
                clickable
                @click="getTownshipData(active,item,index)"
              >
                <van-radio slot="right-icon" checked-color="#4ac08a" :name="index" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
      <van-tab title="科" name="township" class="tabList">
        <div class="townshipBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="keCatlogData == ''">无匹配数据</p>
          <van-radio-group v-model="keRadio">
            <van-cell-group>
              <van-cell
                v-for="(item,index) in keCatlogData"
                :key="item.code"
                :title="`${item.name}`"
                clickable
                @click="getvillageData(active,item,index)"
              >
                <van-radio slot="right-icon" checked-color="#4ac08a" :name="index" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
      <van-tab title="属" name="village" class="tabList">
        <div class="areaBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="shuCatlogData == ''">无匹配数据</p>
          <van-radio-group v-model="shuRadio">
            <van-cell-group>
              <van-cell
                v-for="(item,index) in shuCatlogData"
                :key="item.code"
                :title="`${item.name}`"
                clickable
                @click="getcheck(item,index)"
              >
                <van-radio slot="right-icon" checked-color="#4ac08a" :name="index" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
    </van-tabs>
    <div class="checkedValue">
      <van-cell-group>
        <van-field
          v-model="checkedValue"
          rows="1"
          readonly
          autosize
          label="选中值："
          type="textarea"
          placeholder
        />
      </van-cell-group>
    </div>
    <!-- 操作按钮 -->
    <div class="btnBox clearfix">
      <a href="javascript:void(0);" class="closeBtn" @click="closePicker(1)">取消</a>
      <a href="javascript:void(0);" class="sureBtn" @click="closePicker(2)">确定</a>
    </div>
  </div>
</template>
<script>
import newApi from "lodash";
export default {
  name: "classifySelect",
  props: {
    classifySource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      active: "province",
      topParentCode: "1",
      mencatlog: "", //门
      mencatlogData: [],
      gangCatlog: "", //纲
      gangCatlogData: [],
      muCatlog: "", //目
      muCatlogData: [],
      keCatlog: "", //科
      keCatlogData: [],
      shuCatlog: "", //属
      shuCatlogData: [],
      checkedValue: "", //选中值
      checkedCode: "",
      menRadio: "", //门选中高亮
      gangRadio: "", //纲选中高亮
      muRadio: "", //目选中高亮
      keRadio: "", //科选中高亮
      shuRadio: "", //属选中高亮
      showKong: false //没有内容展示
    };
  },
  mounted() {
    this.$nextTick(function() {
     
      if (this.classifySource.catalogCodeList) {
        let classifyList = this.classifySource.catalogCodeList;
        this.checkedValue = this.classifySource.catalog;
        this.checkedCode = this.classifySource.catalogCodeList;
        this.getSourceData(this.active, this.topParentCode, "1");

        classifyList.splice(0, 1);
        this.getSourceData("city", classifyList[0], "2"); //加载第二级植物分类

        this.getSourceData("area", classifyList[1], "3"); //加载第三级植物分类

        this.getSourceData("township", classifyList[2], "4"); ////加载第四级植物分类

        this.getSourceData("village", classifyList[3], "5"); ////加载第五级植物分类
      } else {
        this.checkedCode = [];
        this.getSourceData(this.active, this.topParentCode, "1");
      }
    });
  },
  methods: {
    getSourceData(name, parentCode, level) {
      let _this = this;
      _this.$api.slbkOldTree
        .getTreeClassify({
          parentCode: parentCode,
          parentLevel: level,
          type: "1"
        })
        .then(res => {
          if (res.code == "1") {
            if (res.data == [] || res.data == "") {
              _this.showKong = true;
            }
            if (name == "province") {
              _this.mencatlogData = res.data;

              if (this.classifySource.catalogCodeList) {
                let provinceIndex = _this.classifySource.catalogCodeList[0];
                _this.mencatlogData.forEach((item, index) => {
                  if (provinceIndex === _this.mencatlogData[index].code) {
                    _this.menRadio = index;
                  }
                });
              }
            } else if (name == "city") {
              _this.gangCatlogData = res.data;
              if (this.classifySource.catalogCodeList) {
                let provinceIndex = _this.classifySource.catalogCodeList[1];
                _this.gangCatlogData.forEach((item, index) => {
                  if (provinceIndex === _this.gangCatlogData[index].code) {
                    _this.gangRadio = index;
                  }
                });
              }
            } else if (name == "area") {
              _this.muCatlogData = res.data;
              if (this.classifySource.catalogCodeList) {
                let provinceIndex = _this.classifySource.catalogCodeList[2];
                _this.muCatlogData.forEach((item, index) => {
                  if (provinceIndex === _this.muCatlogData[index].code) {
                    _this.muRadio = index;
                  }
                });
              }
            } else if (name == "township") {
              _this.keCatlogData = res.data;
              if (this.classifySource.catalogCodeList) {
                let provinceIndex = _this.classifySource.catalogCodeList[3];
                _this.keCatlogData.forEach((item, index) => {
                  if (provinceIndex === _this.keCatlogData[index].code) {
                    _this.keRadio = index;
                  }
                });
              }
            } else if (name == "village") {
              _this.shuCatlogData = res.data;
             
              if (this.classifySource.catalogCodeList) {
                let provinceIndex = _this.classifySource.catalogCodeList[4];
                _this.shuCatlogData.forEach((item, index) => {
                  if (provinceIndex === _this.shuCatlogData[index].code) {
                    _this.shuRadio = index;
                  }
                });
              }
            } else {
              return;
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCityData(name, item, index) {
    

      let _this = this;
      _this.checkedCode[0] = item.code;
      _this.checkedCode.splice(1,4);
      _this.menRadio = index;
      _this.active = "city";
      _this.gangcatlogData = "";
      _this.mucatlogData = "";
      _this.shucatlogData = "";
      _this.gangRadio = ""; //纲选中高亮
      _this.muRadio = ""; //目选中高亮
      _this.keRadio = ""; //科镇选中高亮
      _this.shuRadio = ""; //属选中高亮
      _this.checkedValue = item.name;

      _this.getSourceData(_this.active, item.code, "2");
    },
    getAreaData(name, item, index) {
      let _this = this;
      _this.checkedCode[1] = item.code;
       _this.checkedCode.splice(2,4);
      _this.gangRadio = index;
      _this.active = "area";
      _this.mucatlogData = "";
      _this.shucatlogData = "";
      _this.muRadio = ""; //目选中高亮
      _this.keRadio = ""; //科选中高亮
      _this.shuRadio = ""; //属镇选中高亮

      _this.checkedValue = _this.checkedValue.split(">");
      _this.checkedValue = _this.checkedValue.splice(0, 1) + ">" + item.name;
      _this.getSourceData(_this.active, item.code, "3");
    },
    getTownshipData(name, item, index) {
      let _this = this;
      _this.checkedCode[2] = item.code;
       _this.checkedCode.splice(3,4);
      _this.muRadio = index;
      _this.active = "township";
      _this.shucatlogData = "";

      _this.keRadio = ""; //科选中高亮
      _this.shuRadio = ""; //属镇选中高亮
      _this.checkedValue = _this.checkedValue.split(">");
      _this.checkedValue =
        _this.checkedValue.splice(0, 2).join(">") + ">" + item.name;
      _this.getSourceData(_this.active, item.code, "4");
    },
    getvillageData(name, item, index) {
      let _this = this;
      _this.checkedCode[3] = item.code;
       _this.checkedCode.splice(4,4);
      _this.keRadio = index;
      _this.active = "village";
      _this.shuRadio = ""; //属镇选中高亮
      _this.checkedValue = _this.checkedValue.split(">");
      _this.checkedValue =
        _this.checkedValue.splice(0, 3).join(">") + ">" + item.name;
      _this.getSourceData(_this.active, item.code, "5");
    },
    getcheck(item, index) {
      let _this = this;
      _this.checkedCode[4] = item.code;
      _this.shuRadio = index;
      _this.checkedValue = _this.checkedValue.split(">");
      _this.checkedValue =
        _this.checkedValue.splice(0, 4).join(">") + ">" + item.name;
    },
    
    closePicker(type) {
      let getData = {};
      if (type == "1") {
        getData.type = false;
        this.$emit("changeData", getData);
      } else {
        if (this.checkedCode.length < 5) {
          this.$toast("所属分类必须选择到最后一级！");
        } else {
          getData.type = false;
          getData.code = this.checkedCode;
          getData.name = this.checkedValue;
          
          this.$emit("changeData", getData);
        }
      }
    }
  }
};
</script>
<style lang="less">
 @import "./css/checkSelect.less";

</style>